import { useState } from "react"
import { FaPhone } from "react-icons/fa";
import { IoIosArrowDropdownCircle,IoIosArrowDropupCircle } from "react-icons/io";

export default function Service(params) {
    const [show, setShow] = useState(false)
    function SwapView() {
        setShow(!show)
    }

    console.log(show)
    return (
        <div className="Service">
            {!show &&
                <>
                    <p>{params.text}</p>
                    {/* <IoIosArrowDropdownCircle onClick={() => SwapView()} className="ViewMoreButton" size={30}></IoIosArrowDropdownCircle > */}
                </>}
            {show && <>
                <div className="ServiceInfo">
                    <p>{params.text}</p>
                    <p>{params.description}</p>
                    <a href="tel:4352627460">Call Shane To get started now! <FaPhone fill="black" stroke='black' size={30} /></a>
                </div>
                <IoIosArrowDropupCircle onClick={() => SwapView()} className="ViewMoreButton" size={30}></IoIosArrowDropupCircle >
            </>}

        </div>
    )
}
